export default {"src":"/_next/static/media/threat-modeling.181dfbb5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};